import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LetterWriteFileListFileNameTextComponent } from './file-name-text.component';
import { FileModule } from '@schoolbelle/api/file';

@NgModule({
  declarations: [
    LetterWriteFileListFileNameTextComponent,
  ],
  imports: [
    CommonModule,
    FileModule,
  ],
  exports:[
    LetterWriteFileListFileNameTextComponent,
  ]
})
export class LetterWriteFileListFileNameTextModule { }
